import React from 'react';
import { SuccessIcon, ErrorIcon, WarningIcon, InfoIcon, CloseIcon } from '../../../assets/icons';
import './Toast.css';

const icons = {
  success: SuccessIcon,
  error: ErrorIcon,
  warning: WarningIcon,
  info: InfoIcon
};

const Toast = ({ id, message, type = 'info', onClose }) => {
  const Icon = icons[type] || InfoIcon;

  return (
    <div className={`toast toast-${type}`}>
      <span className="toast-icon">
        <Icon size={20} />
      </span>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={() => onClose(id)}>
        <CloseIcon size={16} />
      </button>
    </div>
  );
};

export default Toast;
